import { Box, Stack, useMediaQuery } from '@chakra-ui/react';
import Text from '@molecules/Text';
import styled from '@emotion/styled';
import ScreenSize from '../../../constants/screen-sizes';
import { useStore } from '@data/other/withStore';
import { observer } from 'mobx-react';
import ShoppingCartCard from './ShoppingCartCard';
import MobileShoppingCart from './mobile';
import { useTranslation } from 'react-i18next';
import BEImage from '@molecules/BEImage';

export interface ShoppingCartProps {
  path?: string;
  onCancel?: () => void;
  onOk?: () => void | Promise<void>;
}

const StyledStyckyContainer = styled(Box)`
  position: sticky;
  top: 120px;
`;

const StyledShoppingCartCard = styled.div`
    position: relative;
    background-color: white;
    width: 340px;
    min-width: 340px;
    box-shadow: 0px 4px 64px rgba(119, 130, 149, 0.1);
    border-radius: 16px;
    display:flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
      width: 100%;
    }
`;

const ShoppingCart = (props: ShoppingCartProps) => {
  const { t } = useTranslation();
  const {
    property: { cart },
  } = useStore();
  const [isMobile] = useMediaQuery(`(max-width: ${ScreenSize.MOBILE_LARGE})`);

  return (
    <>
      {cart.items.length > 0 ? (
        isMobile ? (
          <MobileShoppingCart {...props} />
        ) : (
          <StyledStyckyContainer>
            <ShoppingCartCard {...props} />
          </StyledStyckyContainer>
        )
      ) : isMobile ? null : (
        <>
          <StyledStyckyContainer>
            <StyledShoppingCartCard>
              <Stack p="16px" w="100%" textAlign="center" gap="8px">
                <BEImage
                  width={'100%'}
                  height={'180px'}
                  fallback="bed"
                  borderRadius="16px"
                />
                <Text>{t('no-accommodations-added')}</Text>
              </Stack>
            </StyledShoppingCartCard>
          </StyledStyckyContainer>
        </>
      )}
    </>
  );
};

export default observer(ShoppingCart);
